import {Image, Text, View} from '@react-pdf/renderer';
import React from 'react';
import {styles} from './styles';
import sleipnerLogo from 'assets/logo.png';
import {CustomerDetails} from './CustomerDetails';

export const Header = ({title, customer, background}) => {
	return (
		<View>
			<Image src={background} style={[styles.image.pageBackground, {height: '100px'}]} />

			<View
				style={{
					padding: '40px',
					paddingTop: '20px',
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					marginTop: '8px',
				}}
			>
				<View
					style={[
						styles.text.yellow,
						{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'},
					]}
				>
					<Image src={sleipnerLogo} style={{width: '50px', height: '50px'}} />
					<Text
						style={{
							fontWeight: 600,
							position: 'relative',
							top: '10px',
							left: '10px',
							fontSize: '26px',
						}}
					>
						{title ?? 'Section title'}
					</Text>
				</View>

				<CustomerDetails customer={customer} />
			</View>
		</View>
	);
};
